import { text } from '@fortawesome/fontawesome-svg-core'
import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    Box: {
      marginBottom: 10
    },
    Buttons: {
      columnGap: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    fabIcon: {
      width: '30px',
      height: '30px',
      fontSize: '30px',
      marginRight: 5
    },
    fabLabel: {
      padding: '0 6px 0 4px',
      fontWeight: 500,
      fontSize: '1.0em'
    },
    fabExtended: {
      justifyContent: 'flex-start',
      alignSelf: 'flex-start',
      width: 'auto',
      zIndex: theme && theme.zIndex.drawer,
      boxShadow: '0 1px 2px 0 rgba(60,64,67,0.302), 0 1px 3px 1px rgba(60,64,67,0.149)',
      backgroundColor: '#fff',
      textTransform: 'none',
      marginLeft: 10,
      color: 'default',
      '&:hover': {
        boxShadow: '0 1px 3px 0 rgba(60,64,67,0.302), 0 4px 8px 3px rgba(60,64,67,0.149)',
        backgroundColor: '#fff'
      }
    }
  })
